import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { DrugDetailPage } from './drug-detail';
import { ComponentsModule } from '../../components/components.module';

@NgModule({
  declarations: [
    DrugDetailPage,
  ],
  imports: [
    ComponentsModule,
    IonicPageModule.forChild(DrugDetailPage),
  ],
})
export class DrugDetailPageModule {}



// WEBPACK FOOTER //
// ./src/pages/drug-detail/drug-detail.module.ts